var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-methods-container"},[_c('div',{staticClass:"saved-cards-container"},[_c('add-card-button',{on:{"click":_vm.createPayment}}),_c('div',{staticClass:"cards"},[_c('iframe',{ref:"cardsIframe",attrs:{"src":_vm.src}})])],1),_c('add-card-popup',{attrs:{"opened":_vm.addCardOpened},on:{"close":_vm.closeAddCard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }